"use client";

import { datadogRum } from "@datadog/browser-rum";

let initialized = false;

export function initDatadogRum() {
  if (initialized || typeof window === "undefined") return;
  if (
    !process.env.NEXT_PUBLIC_DD_RUM_APPLICATION_ID ||
    !process.env.NEXT_PUBLIC_DD_RUM_CLIENT_TOKEN
  ) {
    return;
  }

  datadogRum.init({
    applicationId: process.env.NEXT_PUBLIC_DD_RUM_APPLICATION_ID,
    clientToken: process.env.NEXT_PUBLIC_DD_RUM_CLIENT_TOKEN,
    site: process.env.NEXT_PUBLIC_DD_SITE || "us5.datadoghq.com",
    service: "alana-shopping-b2b",
    env: process.env.NEXT_PUBLIC_VERCEL_ENV || process.env.NODE_ENV,
    version: process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA,
    // PostHog handles session replay — disable here to avoid duplicate cost
    sessionReplaySampleRate: 0,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: "mask",
  });

  initialized = true;
}

export { datadogRum };

/**
 * Wrapper around datadogRum.addError that also logs to console.error in
 * non-production environments or when RUM has not been initialized yet.
 * This ensures errors are visible during development and in environments
 * where RUM credentials are not configured.
 */
export function addError(
  error: unknown,
  context?: Record<string, unknown>,
): void {
  if (process.env.NODE_ENV !== "production" || !initialized) {
    console.error("[RUM]", error, context);
  }
  if (initialized) {
    datadogRum.addError(error, context);
  }
}
